module.exports = __webpack_public_path__ + "img/Ausgehen.20dd476f.jpg";